import { HttpErrorResponse } from "@angular/common/http";
import { AfterViewChecked, ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Subject, ReplaySubject } from "rxjs";
import { take, takeUntil } from "rxjs/operators";
import { ClienteOutput } from "src/app/@shared/models/cliente.model";
import { ClienteService } from "src/app/services/cliente/cliente.service";
import { ControleExpedicaoMalhaService } from "src/app/services/controle-expedicao-malha/controle-expedicao-malha.service";
import { PedidosService } from "src/app/services/pedidos/pedidos.service";
import { AgenteService } from "src/app/services/shared/agente/agente.service";
import { StorageService } from "src/app/services/storage/storage.service";
import { MatTableDataSource } from "@angular/material/table";
import { animate, state, style, transition, trigger } from '@angular/animations';
import {
  RequestExpedicaoMalha,
  ResponseExpedicaoMalha,
} from "src/app/@shared/models/controle-expedicao-malha.model";
import { AuthService } from "src/app/services/auth/auth.service";
import { ModalRefreshComponent } from "./modal-refresh/modal-refresh.component";
import { MatDialog } from "@angular/material/dialog";
@Component({
  selector: "app-controle-expedicao-malha",
  templateUrl: "./controle-expedicao-malha.component.html",
  styleUrls: ["./controle-expedicao-malha.component.scss"],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ],
})
export class ControleExpedicaoMalhaComponent implements OnInit, AfterViewChecked {
  @Input() featureId: string;
  public habilitarEditacao: boolean = false;
  public habilitarInclusao: boolean = false;

  isLoading: boolean = false;
  isLoadingDownload: boolean = false;
  usuarioEAgente: boolean;
  usuarioAtual: any;
  expandir: boolean = false;
  objConsultaInicial: RequestExpedicaoMalha;
  rotaId;
  exibirExpandir: boolean = false;

  public exibirGrid: boolean = false;
  comboRotas = [];

  comboDiasFuturos = [
    { id: 1, descricao: "1 dia" },
    { id: 2, descricao: "2 dias" },
    { id: 3, descricao: "3 dias" },
    { id: 4, descricao: "4 dias" },
    { id: 5, descricao: "5 dias" },
    { id: 6, descricao: "6 dias" },
    { id: 7, descricao: "7 dias" },
    { id: 8, descricao: "8 dias" },
    { id: 9, descricao: "9 dias" },
    { id: 10, descricao: "10 dias" },
    { id: 60, descricao: "60 dias"}
  ];

  comboVencidos = [
    { id: 1, descricao: "Vencendo Hoje" },
    { id: 2, descricao: "Vencidos" },
    { id: 3, descricao: "Vencendo nos próximos" },
  ];

  comboRecepcaoBase = [
    { id: 0, descricao: "Todos" },
    { id: 1, descricao: "Recepção na Base" },
    { id: 2, descricao: "Em Rota" },
    { id: 3, descricao: "A caminho da Base" },
    { id: 4, descricao: "Em Pré-Fae" }
  ];

  headerForm = new FormGroup({
    autoRefresh: new FormControl(false),
    timeRefresh: new FormControl()
  });

  get timeRefresh() {
    return this.headerForm.get("timeRefresh").value;
  }


  filterForm = new FormGroup({
    regional: new FormControl(0),
    iataSelecionada: new FormControl(0),
    clienteSelecionado: new FormControl(0),
    recepcaoBaseFormControl: new FormControl(0),
    vencimentoFormControl: new FormControl(0),
    recebimentoFormControl: new FormControl(""),
    pedidosvencendoProximos: new FormControl(""),
    negocioFormControl: new FormControl(),
    flgRota: new FormControl(false),
    rotaSelecionada: new FormControl("")
  });

  get iataSelecionada() {
    return this.filterForm.get("iataSelecionada").value;
  }
  get regional() {
    return this.filterForm.get("regional").value;
  }
  get clienteSelecionado() {
    return this.filterForm.get("clienteSelecionado").value;
  }
  get vencimentoSelecionado() {
    return this.filterForm.get("vencimentoFormControl").value;
  }
  get recebimentoSelecionado() {
    return this.filterForm.get("recebimentoFormControl").value;
  }
  get negocioFormControl() {
    return this.filterForm.get("negocioFormControl").value;
  }
  get recepcaoBase() {
    return this.filterForm.get("recepcaoBaseFormControl").value;
  }
  get pedidosvencendoProximos() {
    if (this.vencimentoSelecionado && Number(this.vencimentoSelecionado) !== 3)
      return 0;
    else
      return this.filterForm.get("pedidosvencendoProximos").value;
  }
  get flgRota() {
    return this.filterForm.get("flgRota").value;
  }
  get rotaSelecionada() {
    return this.filterForm.get("rotaSelecionada").value;
  }

  private onDestroy = new Subject<void>();
  public filteredAgentes: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public agenteMultiFilter: FormControl = new FormControl();
  public filteredClientes: ReplaySubject<ClienteOutput[]> = new ReplaySubject<
    ClienteOutput[]
  >(1);
  public clienteMultiFilter: FormControl = new FormControl();
  public filteredRegional: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public regionalMultiFilter: FormControl = new FormControl();

  public filteredNegocio: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public negocioMultiFilter: FormControl = new FormControl();

  public filteredRotas: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public RotasMultiFilter: FormControl = new FormControl();

  rotas: any[];
  negocios: any[];
  agentes: any[];
  clientes: ClienteOutput[];
  regionais: any[];
  agentId: number;
  element: boolean = false;
  newTime: number;
  intervalRefresh;

  public abrirModal() {
     const dialogRef = this.dialog.open(ModalRefreshComponent, {
      width: '540px',
      data: {
        textoCancelar: "Cancelar",
        textoOk: "Confirmar",
        texto: "Defina um tempo para a atualização automática",
      },
    });
    dialogRef.afterClosed().subscribe(response => {
      this.newTime = response.tempo
        if(response.sucesso){
          this.headerForm.get('timeRefresh').setValue(this.newTime.toString());
          this.ativaRefresh();
        } else {
          this.headerForm.get('autoRefresh').setValue(false);
        }
      });
  };

  ativaRefresh(){
    this.intervalRefresh = setInterval(() => {
      this.pesquisarMalha()}, this.newTime*1000)
    };

  desativaRefresh(){
    clearInterval(this.intervalRefresh);
    this.newTime = undefined;
    this.headerForm.get('timeRefresh').setValue("");
    this.headerForm.get('autoRefresh').setValue(false);
  }


  public headerColspan(tipo_Vencimento = null): number {
    let colspan = this.objConsultaInicial?.tipo_Recebimento > 0 ? 1 : 4;
    // switch (tipo_Vencimento) {
    //   //vencendo hoje
    //   case 1:
    //   //vencidos
    //   case 2:
    //   //proximos dias
    //   case 3:
    //     {
    //       colspan = this.objConsultaInicial?.tipo_Recebimento > 0 ? 1 : 3;
    //       break;
    //     }
    //   default:
    //     {
    //       //total
    //       colspan = !this.objConsultaInicial?.tipo_Vencimento ? 3 : 1;
    //     }
    //     break;
    // }
    return colspan;
  }

  public headerColumns(): any[] {
    var retorno = ['header-row-1'];
    if ((this.objConsultaInicial?.tipo_Vencimento == 2) || !this.objConsultaInicial?.tipo_Vencimento) {
      retorno.push('header-row-pedidos-vencidos');
    }

    if ((this.objConsultaInicial?.tipo_Vencimento == 1) || !this.objConsultaInicial?.tipo_Vencimento) {
      retorno.push('header-row-pedidos-vencendo-hoje');
    }

    if ((this.objConsultaInicial?.tipo_Vencimento == 3) || !this.objConsultaInicial?.tipo_Vencimento ) {
      retorno.push('header-row-pedidos-vencendo-proximos');
    }

    if (!this.objConsultaInicial?.tipo_Vencimento) {
      retorno.push('header-row-total');
    }
    return retorno;
  };

  public displayColumnsCommon(): any[] {
    var retorno = [];
    if (!this.objConsultaInicial?.tipo_Vencimento
      || this.objConsultaInicial?.tipo_Vencimento == 2) {//base

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 3) {
        retorno.push("pedidoS_VENCIDOS_CAMINHO");
      }

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 1) {
        retorno.push("pedidoS_VENCIDOS_RECEPCAO_BASE");
      }

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 4) {
        retorno.push("pedidoS_VENCIDOS_PREFAE");
      }

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 2) {
        retorno.push("pedidoS_VENCIDOS_EM_ROTA");
      }
    }

    if (!this.objConsultaInicial?.tipo_Vencimento
      || this.objConsultaInicial?.tipo_Vencimento == 1) {

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 3) {
        retorno.push("pedidoS_VENCE_HOJE_CAMINHO");
      }

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 1) {
        retorno.push("pedidoS_VENCE_HOJE_RECEPCAO_BASE");
      }

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 4) {
        retorno.push("pedidoS_VENCE_HOJE_PREFAE");
      }

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 2) {
        retorno.push("pedidoS_VENCE_HOJE_ROTA");
      }
    }

    if ((!this.objConsultaInicial?.tipo_Vencimento || this.objConsultaInicial?.tipo_Vencimento == 3) &&
      this.objConsultaInicial?.pedidosVencendo > 0) {


      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 3) {
        retorno.push("pedidoS_VENCENDO_CAMINHO");
      }

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 1) {
        retorno.push("pedidoS_VENCENDO_RECEPCAO_BASE");
      }

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 4) {
        retorno.push("pedidoS_VENCENDO_PREFAE");
      }


      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 2) {
        retorno.push("pedidoS_VENCENDO_ROTA");
      }
    }

    if (!this.objConsultaInicial?.tipo_Vencimento) {

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 3) {
        retorno.push("totaL_CAMINHO");
      }

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 1) {
        retorno.push("totaL_BASE");
      }

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 4) {
        retorno.push("totaL_PREFAE");
      }

      if (!this.objConsultaInicial?.tipo_Recebimento
        || this.objConsultaInicial?.tipo_Recebimento == 2) {
        retorno.push("totaL_ROTA");
      }
    }
    return retorno;
  }

  public displayedColumns(): string[] {
    var retorno = ["iata"].concat(this.displayColumnsCommon());
    return retorno;
  };


  public displayedColumnsRota(): string[] {
    var retorno = ["rota"].concat(this.displayColumnsCommon());
    return retorno;
  };

  expandedElement: ResponseExpedicaoMalha | null;
  public gridMalha: MatTableDataSource<ResponseExpedicaoMalha> = new MatTableDataSource<ResponseExpedicaoMalha>();
  // public paging = { index: 0, size: 10, length: 0 };

  public iataSelecionada_ID: number;
  public vencimentoSelecionado_ID: number;
  public recepcaoSelecionado_ID: number;
  public pedidosvencendoProximos_ID: number;

  constructor(
    public snackBar: MatSnackBar,
    public authService: AuthService,
    private agenteService: AgenteService,
    private cdr: ChangeDetectorRef,
    private clienteService: ClienteService,
    private controleExpedicaoMalhaService: ControleExpedicaoMalhaService,
    private pedidoService: PedidosService,
    private dialog: MatDialog
  ) {
    if (!this.featureId) {
      this.featureId = 'paineis.controle-expedicao-malha';
    }

    this.usuarioAtual = StorageService.getPerfilUsuario();
    this.usuarioEAgente = this.usuarioAtual.perfilacessotipo === 4;
    this.filterForm.get("vencimentoFormControl").setValue(1);
    this.filterForm.get("recepcaoBaseFormControl").setValue(1);
  }

  ngAfterViewChecked(): void {
    this.cdr.detectChanges();
  }

  ngOnInit() {
    this.element = false;
    this.authService.checkFeature(`${this.featureId}.alterar`).subscribe(temPermissao => {
      if (temPermissao === true) this.habilitarEditacao = true;
    })
    this.authService.checkFeature(`${this.featureId}.novo`).subscribe(temPermissao => {
      if (temPermissao === true) this.habilitarInclusao = true;
    })
    this.ListarIatas();
    this.listarRotas();
    this.selecionarAgentes();
    this.listarClientes();
    this.listarRegionais();
    this.listarNegocio();
    this.filterForm.get("negocioFormControl").setValue('');
    this.filterForm.get('pedidosvencendoProximos').setValue('');
  }
  expandirRota(p) {
    if (p) {
      this.expandir = true;
    } else {
      this.expandir = false;
    }
  }

  encodeURI(data: any): string {
    return btoa(JSON.stringify(data));
  }
  public setaFiltro(filter, value) {
    this.filterForm.get(filter).setValue(value);
  }

  public baixarExcelIata(row, tipoVencimento, tipoRecebimento) {
    this.downloadExcel(tipoVencimento, tipoRecebimento, row.agenteId, row.agenteRotaId);
  }

  public baixarExcelRota(row, column) {

    switch (column) {
      case "pedidoS_VENCIDOS_RECEPCAO_BASE":
        this.downloadExcel(1, 2, row.agenteId, row.agenteRotaId);
        break;
      case "pedidoS_VENCIDOS_EM_ROTA":
        this.downloadExcel(2, 2, row.agenteId, row.agenteRotaId);
        break;
      case "pedidoS_VENCIDOS_CAMINHO":
        this.downloadExcel(3, 2, row.agenteId, row.agenteRotaId);
        break;
      case "pedidoS_VENCIDOS_PREFAE":
        this.downloadExcel(4, 2, row.agenteId, row.agenteRotaId);
        break;
      case "pedidoS_VENCE_HOJE_RECEPCAO_BASE":
        this.downloadExcel(1, 1, row.agenteId, row.agenteRotaId);
        break;
      case "pedidoS_VENCE_HOJE_ROTA":
        this.downloadExcel(2, 1, row.agenteId, row.agenteRotaId);
        break;
      case "pedidoS_VENCE_HOJE_CAMINHO":
        this.downloadExcel(3, 1, row.agenteId, row.agenteRotaId);
        break;
      case "pedidoS_VENCE_HOJE_PREFAE":
        this.downloadExcel(4, 1, row.agenteId, row.agenteRotaId);
        break;
      case "pedidoS_VENCENDO_RECEPCAO_BASE":
        this.downloadExcel(1, 3, row.agenteId, row.agenteRotaId);
        break;
      case "pedidoS_VENCENDO_ROTA":
        this.downloadExcel(2, 3, row.agenteId, row.agenteRotaId);
        break;
      case "pedidoS_VENCENDO_CAMINHO":
        this.downloadExcel(3, 3, row.agenteId, row.agenteRotaId);
        break;
      case "pedidoS_VENCENDO_PREFAE":
        this.downloadExcel(4, 3, row.agenteId, row.agenteRotaId);
        break;
      case "totaL_BASE":
        this.downloadExcel(1, this.objConsultaInicial.tipo_Vencimento, row.agenteId, row.agenteRotaId);
        break;
      case "totaL_ROTA":
        this.downloadExcel(2, this.objConsultaInicial.tipo_Vencimento, row.agenteId, row.agenteRotaId);
        break;
      case "totaL_CAMINHO":
        this.downloadExcel(3, this.objConsultaInicial.tipo_Vencimento, row.agenteId, row.agenteRotaId);
        break;
      case "totaL_PREFAE":
        this.downloadExcel(4, this.objConsultaInicial.tipo_Vencimento, row.agenteId, row.agenteRotaId);
        break;
    }
  }

  public ListarIatas() {
    this.agentId = null;
    if (this.regional) {
      this.controleExpedicaoMalhaService
        .listarIatas(Number(this.regional))
        .subscribe(
          (response: any[]) => {
            this.agentes = response
              .filter((x) => x.codIATA && x.fantasia)
              .sort((a, b) => (a.codIATA < b.codIATA ? -1 : 1));
            this.filteredAgentes.next(this.agentes.slice());
            this.agenteMultiFilter.valueChanges
              .pipe(takeUntil(this.onDestroy))
              .subscribe(() => {
                this.filtroGeral(
                  this.agentes,
                  this.agenteMultiFilter,
                  this.filteredAgentes,
                  "codIATA"
                );
              });
          },
          (err: HttpErrorResponse) => {
            console.error(err);
            this.openSnackBar(
              "Ocorreu um erro ao consultar! Tente novamente ou entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
              "OK",
              10000,
              "danger-snackbar"
            );
          }
        )
        .add(() => {
          this.isLoading = false;
        });
    }
  }
  public retornaDiasFiltro() {
    return this.pedidosvencendoProximos;
  }
  public filterRotas(rota) {
    let obj = rota;
    obj.forEach((o) => { delete o.iata; });
    return obj
  }
  public pesquisarMalha() {
    if (
      !this.regional &&
      !this.iataSelecionada &&
      !this.clienteSelecionado &&
      !this.negocioFormControl &&
      !this.usuarioEAgente &&
      !this.recepcaoBase &&
      !this.pedidosvencendoProximos &&
      !this.vencimentoSelecionado
    ) {
      return this.openSnackBar(
        "Preencher ao menos um filtro!",
        "OK",
        5000,
        "warning-snackbar"
      );
    } else {
      this.isLoading = true;
      //  let dados = this.mock;
      //this.paging.length = dados.length;
      // this.gridMalha.data = dados;
      this.exibirGrid = true;
      this.objConsultaInicial = {
        regional: this.regional == 0 ? null  : Number(this.regional),
        agenteId: this.iataSelecionada == 0 ? null : this.iataSelecionada,
        clienteId: this.clienteSelecionado == 0 ? null : this.clienteSelecionado,
        codSegmento: this.negocioFormControl == '' ? null : this.negocioFormControl,
        tipo_Vencimento: this.vencimentoSelecionado ? Number(this.vencimentoSelecionado) : null,
        tipo_Recebimento: this.recepcaoBase ? Number(this.recepcaoBase) : null,
        pedidosVencendo: Number(this.pedidosvencendoProximos),
        flgRota: this.flgRota,
        rotaId: this.rotaSelecionada == '' ? null : Number(this.rotaSelecionada)
      };

      this.controleExpedicaoMalhaService
        .listarGrid(this.objConsultaInicial)
        .subscribe(
          (response: any) => {
            this.gridMalha.data = response;
            this.exibirGrid = true;
          },
          (err: HttpErrorResponse) => {
            console.error(err);
            this.openSnackBar(
              "Ocorreu um erro ao consultar! Tente novamente ou entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
              "OK",
              10000,
              "danger-snackbar"
            );
          }
        )
        .add(() => {
          this.isLoading = false;
        });
    }
  }
  onPageChange(evt: { pageIndex: number; pageSize: number }) {
    // this.paging.index = evt.pageIndex;
    // this.paging.size = evt.pageSize;
    this.pesquisarMalha();
  }
  public async listarRotas() {
    if (this.regional) {
      let obj = {
        regional: this.regional,
        agenteID: this.iataSelecionada == 0 ? null : this.iataSelecionada
      }
      return this.controleExpedicaoMalhaService
        .listarRotas(obj)
        .toPromise()
        .then(
          (response: any[]) => {
            this.rotas = response
              .filter((x) => x.description != "")
              .sort((a, b) => (a.description < b.description ? -1 : 1));
            this.filteredRotas.next(this.rotas.slice());
            this.RotasMultiFilter.valueChanges
              .pipe(takeUntil(this.onDestroy))
              .subscribe(() => {
                this.filtroGeral(
                  this.rotas,
                  this.RotasMultiFilter,
                  this.filteredRotas,
                  "description"
                );
              });
          },
          (err: HttpErrorResponse) => {
            this.isLoading = false;
            this.openSnackBar(
              "Erro ao carregar negócios, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
              "OK",
              10000,
              "danger-snackbar"
            );
          }
        );
    }
  }

  public async listarClientes() {
    return this.clienteService
      .list()
      .toPromise()
      .then(
        (response: ClienteOutput[]) => {
          this.clientes = response
            .filter((x) => x.nome != "")
            .sort((a, b) => (a.nome < b.nome ? -1 : 1));
          this.filteredClientes.next(this.clientes.slice());
          this.clienteMultiFilter.valueChanges
            .pipe(takeUntil(this.onDestroy))
            .subscribe(() => {
              this.filtroGeral(
                this.clientes,
                this.clienteMultiFilter,
                this.filteredClientes,
                "nome"
              );
            });
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.openSnackBar(
            "Erro ao carregar clientes, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public async listarRegionais() {
    return this.controleExpedicaoMalhaService
      .listarRegionais()
      .toPromise()
      .then(
        (response: any[]) => {
          this.regionais = response
            .filter((x) => x.nome != "")
            .sort((a, b) => (a.nome < b.nome ? -1 : 1));
          this.filteredRegional.next(this.regionais.slice());
          this.regionalMultiFilter.valueChanges
            .pipe(takeUntil(this.onDestroy))
            .subscribe(() => {
              this.filtroGeral(
                this.regionais,
                this.regionalMultiFilter,
                this.filteredRegional,
                "nome"
              );
            });
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.openSnackBar(
            "Erro ao carregar regionais, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public async listarNegocio() {
    return this.pedidoService
      .selecionarClasses()
      .toPromise()
      .then(
        (response: any[]) => {
          this.negocios = response
            .filter((x) => x.nome != "")
            .sort((a, b) => (a.nome < b.nome ? -1 : 1));
          this.filteredNegocio.next(this.negocios.slice());
          this.negocioMultiFilter.valueChanges
            .pipe(takeUntil(this.onDestroy))
            .subscribe(() => {
              this.filtroGeral(
                this.negocios,
                this.negocioMultiFilter,
                this.filteredNegocio,
                "nome"
              );
            });
        },
        (err: HttpErrorResponse) => {
          this.isLoading = false;
          this.openSnackBar(
            "Erro ao carregar negócios, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
            "OK",
            10000,
            "danger-snackbar"
          );
        }
      );
  }

  public selecionarAgentes() {
    this.agenteService.selecionarAgentes().subscribe(
      (response: any[]) => {
        this.agentes = response
          .filter((x) => x.codIATA && x.fantasia)
          .sort((a, b) => (a.codIATA < b.codIATA ? -1 : 1));
        this.filteredAgentes.next(this.agentes.slice());
        this.agenteMultiFilter.valueChanges
          .pipe(takeUntil(this.onDestroy))
          .subscribe(() => {
            this.filtroGeral(
              this.agentes,
              this.agenteMultiFilter,
              this.filteredAgentes,
              "codIATA"
            );
          });
      },
      (err: HttpErrorResponse) => {
        console.error(err);
        this.isLoading = false;
        this.openSnackBar(
          "Erro ao carregar agentes, entre em contato com o suporte : " + err.error.Protocolo ?? err.error.Message,
          "OK",
          10000,
          "danger-snackbar"
        );
      }
    );
  }

  private filtroGeral(
    filtro: any,
    multifilter: any,
    filtered: any,
    field: string
  ) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(
        (response) => response[field].toLowerCase().indexOf(search) > -1
      )
    );
  }

  base64ToArrayBuffer(base64) {
    const binaryString = window.atob(base64);
    const binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
      const ascii = binaryString.charCodeAt(i);
      bytes[i] = ascii;
    }
    return bytes;
  }

  gerarArquivo(data: any, filename: string, type: string) {
    const arrBuffer = this.base64ToArrayBuffer(data);
    const blob = new Blob([arrBuffer], {
      type,
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  downloadExcel(tipoVencimento, tipoRecebimento, agenteId, agenteRotaId) {

    if (
      !this.regional &&
      !this.iataSelecionada &&
      !this.clienteSelecionado &&
      !this.negocioFormControl &&
      !this.usuarioEAgente &&
      !this.recepcaoBase &&
      !this.pedidosvencendoProximos &&
      !this.vencimentoSelecionado

    ) {
      return this.openSnackBar(
        "Preencher ao menos um campo para download!",
        "OK",
        5000,
        "warning-snackbar"
      );
    } else {
      this.isLoadingDownload = true;
      var filterExcel = {
        ...this.objConsultaInicial,
        agenteId: agenteId,
        tipo_Recebimento: tipoRecebimento,
        tipo_Vencimento: tipoVencimento,
        rotaId: agenteRotaId
      };
      // let objModelo;
      // if (this.objConsultaInicial && param == 'todos') {
      //   objModelo = this.objConsultaInicial;
      // } else {
      //   objModelo = obj;
      // }
      this.controleExpedicaoMalhaService.ExportarExcel(filterExcel).subscribe(
        (response: any) => {
          this.gerarArquivo(
            response.retorno.fileContents,
            response.retorno.fileDownloadName,
            response.retorno.contentType
          );
          this.isLoadingDownload = false;
        },

        (err: HttpErrorResponse) => {
          console.error(err);
          this.isLoadingDownload = false;
          this.openSnackBar(`O Download falhou!`, 'OK', 2000, 'danger-snackbar');
        });

    }
  }

  clearFields() {
    //this.paging.length =0;
    this.exibirGrid = false;
    this.gridMalha.data = null;
    this.filterForm.reset();
    this.filterForm.updateValueAndValidity();
    this.filterForm.get("clienteSelecionado").setValue(0);
    this.filterForm.get("regional").setValue(0);
    this.filterForm.get("iataSelecionada").setValue(0);
    this.filterForm.get("vencimentoFormControl").setValue(1);
    this.filterForm.get("recepcaoBaseFormControl").setValue(1);
    this.filterForm.get("pedidosvencendoProximos").setValue('0');
    this.filterForm.get("negocioFormControl").setValue('');
    this.filterForm.get("flgRota").setValue(false);
  }

  openSnackBar(
    message: string,
    action: string,
    duration: number,
    panelClass?: string
  ): any {
    this.snackBar.open(message, action, { duration, panelClass });
  }
}
